import { nativeHandler, getAppInfo } from 'utils';
import store from 'redux/store';

export const CLEVERTAP = {
	EVENTS: {
		CC_PAYMENT: 'ccpayment',
		INELIGIBLE: 'ineligible',
		CARD_ORDER: 'card_order',
		ADDITIONAL_DETAILS: 'additional_details',
		CONTACT_REF: 'contact ref',
		ANNUAL_INCOME: 'Onboarding Income Declaration Proceed Click',
		PHYSICAL_CARD_ORDER: 'physical_card_order',
		ICC_CHAMPIONSHIP: 'icc_championship',
		API_ERROR_503: 'api_error_503',
		API_ERROR: 'api_error',
		UPGRADE_SCREEN: 'upgrade_screen',
		SECURE_BANNER_CLICK: 'cchome_securebanner_click',
		CCBP_HOME_PAGE_VIEW: 'cchome_view',
		SOMETHING_WENT_WRONG: 'something_went_wrong',
		UPDATE_APP: 'update_app',
		TOKENISATIONV2: 'tokenisation v2',
		LP_CARD: 'lp_card',
		BBPS_TILE_VIEWED: 'BBPS tile viewed',
		BBPS_TILE_CLICKED: 'BBPS tile clicked',
		BBPS_C1_BANNER: 'bbps c1 banner',
		MIGRATION: 'lender migrate',
		APP_VERSION_NULL: 'app_version_null',
		CASHMAX: 'cashmax',
		DSA_AU_CC: 'DSA_AU_CC',
		CCBP_PVP_FLOW: 'CCBP_PVP_FLOW',
		BIN_UNSUPPORTED: 'bin_unsupported',
		QR_LOAN: 'qr_loan',
		VAS_DEBIT_MODE: 'vas_debit_mode',
		ONDC: 'ONDC',
	},
	EVENT_PARAMS: {
		UPDATE_APP: {
			ACTION: {
				LOAD: 'loaded',
				LATER_CLICK: 'later_clicked',
				UPDATE_CLICK: 'update_clicked',
			},
			EVENTS_NAME: {
				SOFT_UPDATE: 'soft_update',
				FORCE_UPDATE: 'force_update',
			},
		},
		INELIGIBLE: {
			SCREEN: {
				INELIGIBLE: 'ineligible',
			},
			MODULE: {
				REFER_CLICKED: 'refer_clicked',
				REFER_COPYLINK_CLICKED: 'refer_copylink_clicked',
				PAYCC_SHOWN: 'paycc_shown',
				PAYCC_CLICKED: 'paycc_clicked',
			},
			ACTION: {
				SHOW: 'shown',
				CLICK: 'clicked',
			},
			GENERAL: {
				INELIGIBLE_USER: 'ineligible_user',
			},
		},
		CC_PAYMENT: {
			SCREEN: {
				WAITLIST: 'ineligible',
				ELIGIBLE: 'home_eligible_clicked',
				GET_STARTED: 'cchome_getstarted',
				GET_STARTED_CLICK: 'cchome_getstarted_clicked',
				CARDLIST: 'cchome_cardlist',
				CARDLIST_CLICK: 'cchome_cardlist_clicked',
				ENTER_AMOUNT: 'enter_amount',
				PAYMENT_MODE: 'payment_mode_postpe',
				PAYMENT_MODE_CLICKED: 'payment_mode_clicked',
				TXN_STATUS: 'transaction_status',
				TXN_STATUS_CLICKED: 'transaction_status_clicked',
				CCBP_HOME: 'ccbp_home',
			},
			MODULE: {
				BANNER: 'pay_ccbill_card',
				GET_STARTED: 'get_started',
				POSTPE_NOW: 'cc_postpenow',
				POSTPE_NOW_CONFIRM: 'cc_postpenow_confirm',
				ADD_CARD: 'add_card',
				ADD_CARD_CONFIRM: 'add_card_confirm',
				BILL_PAY: 'ccbill_pay',
				PAYMENT_HISTORY: 'payment_history',
				PAYMENT_MODE: 'payment_mode',
				TXN_STATUS: 'txn_status',
				TXN_SUCCESS: 'txn_success',
				TXN_DONE: 'txn_done',
				SPLIT_PAYMENT_CHECKED: 'ccbp_use_postpe_checkbox',
				SPLIT_PAYMENT_CONFIRMED: 'ccbp_use_postpe_checkbox_confirm',
				SPLIT_PAYMENT_POST_LIMIT_USED: 'ccbp_confirm_payment_paynow',
				SPLIT_PAYMENT_DEBIT_TXN: 'ccbp_transaction_status_pay_balance',
			},
			ACTION: {
				CLICK: 'clicked',
				LOAD: 'loaded',
				SHOW: 'shown',
			},
			GENERAL: {
				ELIGIBLE_USER: 'eligible_user',
				WAITLIST_USER: 'ineligible_user',
				NEW_USER: 'new_user',
				EXISTING_USER: 'existing_user',
			},
			STATUS: {
				SUCCESS: 'success',
				PENDING: 'pending',
				FAIL: 'failed',
			},
		},
		CARD_ORDER: {
			SCREEN: {
				HOME: 'home_page',
				INFO: 'info_screen',
				ADDRESS: 'address_screen',
				NAME: 'name_screen',
				FAILED: 'failed_screen',
				STATUS: 'status_screen',
				ORDERED: 'order_placed',
			},
			MODULE: {
				AWB_LINK: 'awb_link',
				ACTIVATE: 'activate_now',
				ORDERED: 'order_placed',
			},
			ACTION: {
				CLICK: 'clicked',
				LOAD: 'loaded',
				INPUT: 'input',
				SELECT: 'select',
			},
		},
		ANNUAL_INCOME: {
			EVENTS_NAME: {
				ANNUAL_INCOME: 'onboarding_proceed_click',
			},
			SCREEN: {
				INCOME_DECLARATION: 'income_declaration',
			},
			ACTION: {
				CLICK: 'clicked',
				LOAD: 'loaded',
			},
		},
		ADDITIONAL_DETAILS: {
			SCREEN: {
				ADD_NOW: 'add_now',
			},
			NAME: {
				EMAIL_DETAILS: 'email_details',
				EMAIL_SUBMITTED: 'email_submitted',
				ADDRESS_DETAILS: 'address_details',
				ADDRESS_SUBMITTED: 'address_submitted',
				ADDRESS_SKIP: 'address_skip',
			},
			ACTION: {
				LOAD: 'loaded',
				CLICK: 'clicked',
			},
		},
		MIGRATION: {
			EVENTS_NAME: {
				INITIATE: 'TN_LL_Migration_load',
				CONTINUE_CLICK: 'TN_LL_Migration_Accepted',
			},
			ACTION: {
				LOAD: 'loaded',
				CLICK: 'clicked',
			},
		},
		TOKENISATIONV2: {
			EVENTS_NAME: {
				SECURECARD_MODAL_VIEWED: 'securecard_modal_viewed',
				SECURECARD_MODAL_SECURE_NOW_BTN: 'securecard_modal_securenow_clicked',
				SECURECARD_MODAL_SECURE_LATER_BTN: 'securecard_modal_securelater_clicked',
				SECURE_NOW_WHY_SECURE_PAGE: 'secure_now_clicked',
				CONGRATULATIONS_MODAL_TOKENISATION: 'securecard_congratulations_viewed',
				SECURE_CARD_FAILED: 'securecard_failure_viewed',
			},
			SCREEN: {
				TRANSACTION_STATUS: 'transaction_status',
				WHY_SECURE: 'why_secure',
				CCBP: 'ccbp_home',
			},
			ACTION: {
				LOAD: 'loaded',
				CLICK: 'clicked',
			},
		},
		CASHBACK_SCRATCHCARD: {
			EVENTS_NAME: {
				SCRATCHCARD_SEEN: 'scratch card seen',
				SCRATCHCARD_BANNER_CLICK: 'click scratch banner',
				SCRATCHCARD_SCREEN_VIEWED: 'view scratch card screen',
				SCRATCHCARD_CLICK: 'click scratch card',
				SCRATCHCARD_SCRATCHED: 'scratched',
				SCRATCHCARD_CLOSED: 'scratch card click ok or close',
				CASHBACK_HP_TILE_CLICK: 'click cashback tile',
				CASHBACK_SCREEN_VIEWED: 'view cashback screen',
			},
			SCREEN: {
				TXN_STATUS: 'transaction_status',
				POSTPE_HP: 'postpe homepage',
				CASHBACK_SCREEN: 'cashback_screen',
				SCRATCHCARD_SCREEN: 'scratchcard_screen',
			},
		},
		CONTACT_REF: {
			EVENTS_NAME: {
				CONTACT_REF: 'contact_ref',
			},
			SCREEN: {
				CONTACT_REF: 'contact_ref',
				CONTACT_REF_SUCCESS: 'contact_referred_success',
			},
			ACTION: {
				LOAD: 'loaded',
				CLICK: 'clicked',
			},
		},
		BBPS_FLOW: {
			SCREEN: {
				POSTPE_HOMEPAGE: 'postpe homepage',
			},
			ACTION: {
				LOAD: 'loaded',
				CLICK: 'clicked',
				BUTTON_ACTIVE: 'button_active',
			},
		},
		CASHMAX: {
			EVENTS_NAME: {
				CM_HOME_LOAD: 'CM_Home_Page_Load',
				CM_BUTTON_CLICK: 'CM_Home_CTA',
				PL_ENABLED: 'CM_Eligible',
				MIN_PL_LIMIT_USED: 'Min_PL_Limit_Used',
				MIN_PL_LIMIT_USED_FALSE: 'CM_Eligible_Min_PL_Limit_Used_False',
			},
			SCREEN: {
				HOME_PAGE: 'home_page',
			},
			ACTION: {
				LOAD: 'load',
				CLICK: 'click',
			},
		},
		DSA_AU_CC: {
			EVENTS_NAME: {
				HOMEPAGE_BANNER_LOAD: 'CCDSA_AU_Banner_Load',
				HOMEPAGE_BANNER_CLICKED: 'CCDSA_AU_Banner_Clicked',
				APPLY_BTN_CLICKED: 'CCDSA_AU_Lead',
			},
			SCREEN: {
				HOME: 'Homepage',
				AU_CC: 'CCDSA_Landing page',
			},
			ACTION: {
				LOAD: 'loaded',
				CLICK: 'clicked',
			},
		},
		CCBP_PVP_FLOW: {
			EVENTS_NAME: {
				POSTPE_HOME_PENDING_ACTION_TILE_CLICK: 'postpe homepage pending action tile_click',
				CCBP_HOME_PENDING_ACTION_TILE_CLICK: 'ccbp homepage pending action tile_click',
				CCBP_SM_EDUCATION_BANNER: 'ccbp_sm_education_banner',
				POSTPE_HOME_SM_BANNER_CLICK: 'postpe homepage CCBP sm banner_click',
				CCBP_SM_EDUCATION_VIEW: 'ccbp_smeducation_screen_view',
				CCBP_SM_EDUCATION_CLICK: 'ccbp_smeducation_screen_click',
				PAYMENT_MODE: 'payment_mode',
				CLICK_TRANSFER_NOW: 'click_transfer_now',
				CHANGE_BANK: 'change_bank',
				SELECT_BANK: 'select_bank',
				ADD_ACCOUNT: 'add_account',
				CLICK_PAY_NOW: 'click_pay_now',
				INFO_CASHBACK: 'info_cashback',
				CLICK_VIEW_DETAILS: 'click_view details',
				VIEW_SM_STATUS: 'view_sm_status',
				CLICK_CTA_TITLE: 'click_cta_tile',
				VIEW_PENDING_PAYMENT: 'view_pending_payment',
			},
			SCREEN: {
				POSTPE_HOME: 'postpe_homepage',
				CCBP_HOME: 'ccbp_home',
				CCBP_SM_EDUCATION: 'ccbp_smeducation_screen',
				ENTER_AMOUNT: 'enter_amount',
				STEPPER1: 'stepper_screen_1',
				STEPPER2: 'stepper_screen_2',
				CHOOSE_BANK: 'choose_bank',
				SM_STATUS: 'sm_statusscreen',
				PENDING_CCBP: 'pending_ccbp_payment',
			},
			ACTION: {
				LOAD: 'loaded',
				CLICK: 'clicked',
			},
			EVENT_PROPERTY: {
				TXN_STATUS: 'txnStatus',
				ERROR_MSG: 'error_message',
				CARD_LAST4DIGITS: 'card_last4digits',
				CARD_BANKNAME: 'card_bankname',
				CARD_BIN: 'card_bin',
				AMOUNT: 'amount',
				SIM_BINDING_STATUS: 'sim binding status',
				BILL_VALUE: 'bill_value',
				POSTPE_LIMIT: 'postpe_limit',
				SCRATCH_CARD_STATUS: 'scratch_card_status',
				CCBP_SM_AVAILABLE_LIMIT: 'ccbp send money available limit',
				USER_ID: 'user id',
				SM_LIMIT: 'send_money_limit',
				PAYMENT_MODE: 'payment_mode',
				SCREEN_NAME: 'screen_name',
				SM_BANK_NAME: 'sm_bank name',
				SM_BANK_ACCOUNT: 'sm_bank account',
				SCREEN_STATUS: 'screen_status',
				SM_BANK_CODE: 'sm_bank code',
			},
		},
		DSA_LNT_LOAN: {
			EVENTS_NAME: {
				DSA_LTF_OFFER_UPDATED: 'DSA_LTF_OFFER_UPDATED',
				DSA_LTF_APPLICATION_PENDING: 'DSA_LTF_APPLICATION_PENDING',
			},
			SCREEN: {
				HOME_PAGE: 'Homepage',
			},

			ACTION: {
				SHOW: 'shown',
				CLICK: 'clicked',
			},
		},
		QR_LOAN: {
			EVENTS_NAME: {
				QR_LOAN_BANNER_LOAD: 'QR_Loan_Banner_Load',
				QR_LOAN_BANNER_CTA: 'QR_Loan_Banner_CTA',
				LANDING_PAGE_LOAD: 'Landing_Page_Load',
				LANDING_PAGE_CLICK: 'Landing_Page_Click',
				CONVERT_TO_EMI_LOAD: 'Convert_to_EMI_Load',
				CONVERT_TO_EMI_ACTIVE: 'Convert_to_EMI_Active',
				CONVERT_TO_EMI_CTA: 'Convert_to_EMI_CTA',
				TENURE_SELECT: 'Tenure_Select',
				QR_LOAN_CTA: 'QR_Loan_CTA',
				QR_LOAN_KFS_CTA: 'QR_Loan_KFS_CTA',
			},
			SCREEN: {
				HOMESCREEN: 'Homescreen',
				LANDING_PAGE: 'Landing_Page',
				QR_AMOUNT_ENTER_PAGE: 'QR_Amount_enter_Page',
				CONVERT_TO_EMI: 'Convert to EMI',
				TRANSACTION_SUCCESS: 'Transaction Success',
			},

			ACTION: {
				SHOW: 'shown',
				CLICK: 'clicked',
				LOAD: 'load',
			},
			EVENT_PARAMS: {
				CONVERT_TO_EMI_LIMIT: 'Convert to EMI Limit',
				AMOUNT_SELECTED: 'Amount Selected',
				TENURE_SELECTED: 'Tenure Selected',
				MAX_TENURE: 'Max Tenure',
			},
		},
		ONDC: {
			EVENTS_NAME: {
				C1_BANNER_CLICK: 'ONDC_C1_Banner_click',
				TILE_CLICK: 'ONDC_tile_click',
			},
			SCREEN: {
				POSTPE_HOMEPAGE: 'postpe_homepage',
			},
			ACTION: {
				CLICK: 'clicked',
			},
			EVENT_PARAMS: {},
		},
	},
};

export const CleverTapEventV2 = {
	send: (eventName, eventParams) => {
		const DEFAULT_PARAMS = {
			mobile: store?.getState()?.homeDetails?.mobileNumber,
			latitude: getAppInfo()?.latitude || '',
			longitude: getAppInfo()?.longitude || '',
			marketing_event: 'yes',
		};

		const params = { ...DEFAULT_PARAMS, ...eventParams };

		console.log('eventName', eventName);
		console.log('eventParams', params);
		nativeHandler.sendCleverTapEvent(eventName, params);
	},
};
